import React, { useState } from "react";
import PaymentsTable from "../../components/PaymentsTable/payments";
import GstInvoiceExportModal from "../../components/GstInvoiceExportModal/GstInvoiceExportModal";
import { getUserRoles } from "../../utils/helpers";
import { ROLES } from "../../utils/constants";

function Payments() {
    const [showExportModal, setShowExportModal] = useState(false);

    const userRoles = getUserRoles();
    const canExportGst = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SUPPORT, ROLES.SUPER_SUPPORT].some((r) => userRoles.includes(r));

    return (
        <div className="p-7 h-full overflow-y-scroll bg-gray-50">
            {canExportGst && (
                <div className="flex justify-end mb-4">
                    <button
                        type="button"
                        onClick={() => setShowExportModal(true)}
                        className="bg-green-600 text-white-50 font-medium py-2 px-4 rounded shadow hover:bg-green-700 transition-colors text-sm"
                    >
                        Export GST Invoices
                    </button>
                </div>
            )}
            <PaymentsTable />
            {showExportModal && (
                <GstInvoiceExportModal onClose={() => setShowExportModal(false)} />
            )}
        </div>
    );
}

export { Payments };
